/**
 * Tenant shell — nav mirrors app_router.dart:138-144 plus the child routes at
 * app_router.dart:286-335.
 */
import { Dashboard, Money, ToolBox, Chat, Notification, User, WarningAlt } from '@carbon/icons-react';
import { ShellFrame, type NavItem } from './ShellFrame';

const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Dashboard', to: '/tenant', end: true, icon: Dashboard },
  { label: 'Payments', to: '/tenant/payments', icon: Money },
  { label: 'Maintenance', to: '/tenant/maintenance', icon: ToolBox },
  { label: 'Messages', to: '/tenant/messages', icon: Chat },
  { label: 'Eviction notices', to: '/tenant/eviction-notices', icon: WarningAlt },
  { label: 'Notifications', to: '/tenant/notifications', icon: Notification },
  { label: 'Profile', to: '/tenant/profile', icon: User },
];

export function TenantShell(): React.JSX.Element {
  return <ShellFrame title="Tenant" navItems={NAV_ITEMS} />;
}

export default TenantShell;
